var _mask, _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommunity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    width: 50,
    height: 50,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "commCutout"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 25 9.5 C 21.7 9.5 19 12.6 19 16.5 C 19 19.8 20.6 22.5 22.2 23.5 L 22.2 26 C 19.5 27 15.5 28.8 14 31 C 13.5 32 13.5 34.5 13.5 39.5 L 36.5 39.5 C 36.5 34.5 36.5 32 36 31 C 34.5 28.8 30.5 27 27.8 26 L 27.8 23.5 C 29.4 22.5 31 19.8 31 16.5 C 31 12.6 28.3 9.5 25 9.5 Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 3,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#commCutout)",
    fill: "#246e33"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 13.5 12.5 C 10.8 12.5 8.7 15 8.7 18 C 8.7 20.8 10 22.8 11.2 23.8 L 11.2 26 C 9 26.8 6.8 28.5 5.8 30.5 L 5.8 37.5 L 21.2 37.5 L 21.2 30.5 C 20.2 28.5 18 26.8 15.8 26 L 15.8 23.8 C 17 22.8 18.3 20.8 18.3 18 C 18.3 15 16.2 12.5 13.5 12.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 36.5 12.5 C 39.2 12.5 41.3 15 41.3 18 C 41.3 20.8 40 22.8 38.8 23.8 L 38.8 26 C 41 26.8 43.2 28.5 44.2 30.5 L 44.2 37.5 L 28.8 37.5 L 28.8 30.5 C 29.8 28.5 32 26.8 34.2 26 L 34.2 23.8 C 33 22.8 31.7 20.8 31.7 18 C 31.7 15 33.8 12.5 36.5 12.5 Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 25 9.5 C 21.7 9.5 19 12.6 19 16.5 C 19 19.8 20.6 22.5 22.2 23.5 L 22.2 26 C 19.5 27 15.5 28.8 14 31 C 13.5 32 13.5 34.5 13.5 39.5 L 36.5 39.5 C 36.5 34.5 36.5 32 36 31 C 34.5 28.8 30.5 27 27.8 26 L 27.8 23.5 C 29.4 22.5 31 19.8 31 16.5 C 31 12.6 28.3 9.5 25 9.5 Z",
    fill: "#246e33"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunity);
export default __webpack_public_path__ + "static/media/community.346ee65e33bd6ab9db8516505c5f747f.svg";
export { ForwardRef as ReactComponent };